import { Box, IconButton, InputBase, Paper } from "@mui/material";
import { DiscoverTabView, DiscoverViewContext } from "contexts/DiscoverView";
import { KeyboardEvent, useContext, useState } from "react";

const PALETTE = {
  background: "#fafaf6",
  border: "rgba(1, 67, 57, 0.1)",
  iconBg: "#014339",
  placeholder: "#4A5565",
};

const AssistantBubble = () => {
  const { discoverTab, openAssistant } = useContext(DiscoverViewContext);
  const [value, setValue] = useState("");
  const [dismissed, setDismissed] = useState(false);

  if (dismissed || discoverTab === DiscoverTabView.ASSISTANT) return null;

  const submit = () => {
    const text = value.trim();
    if (!text) return;
    openAssistant({
      promptPage: "home",
      source: "Floating Bubble",
      initialMessage: text,
    });
    setValue("");
  };

  const handleKeyDown = (e: KeyboardEvent) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      submit();
    }
  };

  return (
    <Paper
      elevation={6}
      sx={{
        position: "fixed",
        bottom: 24,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: (theme) => theme.zIndex.drawer - 1,
        display: { xs: "none", md: "flex" },
        alignItems: "center",
        gap: 1,
        pl: 1,
        pr: 0.5,
        py: 0.5,
        width: 320,
        maxWidth: "calc(100vw - 120px)",
        borderRadius: 999,
        border: `1px solid ${PALETTE.border}`,
        backgroundColor: PALETTE.background,
      }}
    >
      <Box
        sx={{
          width: 28,
          height: 28,
          borderRadius: "50%",
          backgroundColor: PALETTE.iconBg,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <Box
          component="i"
          className="fa-solid fa-sparkles"
          sx={{ color: "white", fontSize: 13 }}
        />
      </Box>
      <InputBase
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="Ask Bento AI anything..."
        sx={{
          flex: 1,
          fontSize: 14,
          color: "#0f172a",
          "& input::placeholder": { color: PALETTE.placeholder, opacity: 1 },
        }}
      />
      {value.trim() ? (
        <IconButton
          aria-label="Send message"
          onClick={submit}
          size="small"
          sx={{ color: PALETTE.iconBg }}
        >
          <Box
            component="i"
            className="fa-solid fa-arrow-up"
            sx={{ fontSize: 14 }}
          />
        </IconButton>
      ) : (
        <IconButton
          aria-label="Dismiss"
          onClick={() => setDismissed(true)}
          size="small"
          sx={{ color: PALETTE.placeholder }}
        >
          <Box
            component="i"
            className="fa-solid fa-xmark"
            sx={{ fontSize: 14 }}
          />
        </IconButton>
      )}
    </Paper>
  );
};

export default AssistantBubble;
